import { render, staticRenderFns } from "./RootTable.vue?vue&type=template&id=021877d9&scoped=true"
import script from "./RootTable.vue?vue&type=script&lang=js"
export * from "./RootTable.vue?vue&type=script&lang=js"
import style0 from "./RootTable.vue?vue&type=style&index=0&id=021877d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021877d9",
  null
  
)

export default component.exports